module.exports = __webpack_public_path__ + "static/media/funded-by-the-eu-horizontal.facdf7ae.jpg";